import { IncidentFormTypeSchema } from "../../types/incidentWorkItem.js";
import type { ActionInput } from "../ActionInput.js";

export function hasSharedForm({
  incidentWorkItem,
}: Pick<ActionInput, "incidentWorkItem">): boolean {
  return incidentWorkItem.forms.some(
    (form) => form.formType === IncidentFormTypeSchema.enum.shareIncident,
  );
}
